module.exports = __webpack_public_path__ + "img/doricmor_logo_2.45b29172.jpg";